/** @format */
import { decimalToCent } from '@toucan/client/global/currency';
import {
    InternalMediaServiceImage,
    LegacyProductImage,
    ProductState,
    ProductSummaryV2,
    productConditionStringToEnum,
} from '@toucan/client/global/product';

import { ProductLookupProduct, ProductSummaryResponse } from './types';

export function transformProductIdFromSkuResponse(
    ProductIdFromSkuResponse: ProductLookupProduct
): number | undefined {
    return ProductIdFromSkuResponse.id;
}

export function transformProductSummaryImagesResponse(
    images: InternalMediaServiceImage[]
): LegacyProductImage[] {
    return images.map(({ alt, url, fid, index }) => ({
        alt,
        url,
        product: '',
        image: fid,
        imageUrl: url,
        thumb: url,
        ordering: index,
    }));
}

export function transformProductSummaryResponse({
    discount,
    listPrice,
    condition,
    name,
    modelName,
    state,
    images,
    internalImages,
    ...productSummaryResponse
}: ProductSummaryResponse): ProductSummaryV2 {
    const price = listPrice ?? 0;
    return {
        ...productSummaryResponse,
        state,
        modelName,
        discount: discount?.toString(),
        listPrice: price.toString(),
        value: decimalToCent(price),
        condition: productConditionStringToEnum(condition),
        name: name || modelName,
        isSold: state === ProductState.SHIPPED,
        images: transformProductSummaryImagesResponse(images ?? []),
        internalImages: transformProductSummaryImagesResponse(
            internalImages ?? []
        ),
    };
}
